import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { videoEmbedUrl } from "./resourceUtils";

export const VideoLightbox = ({ resource, onClose }) => {
    const embed = resource ? videoEmbedUrl(resource.url) : null;
    return (
        <Dialog open={!!resource} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-4xl p-0 pt-12 overflow-hidden bg-[#1F1F14] border-0 [&>button]:text-[#FBFAF7] [&>button]:opacity-90 [&>button]:top-3 [&>button]:right-3 [&>button]:p-1.5 [&>button>svg]:h-5 [&>button>svg]:w-5" data-testid="video-lightbox">
                <DialogTitle className="sr-only">{resource?.title}</DialogTitle>
                <DialogDescription className="sr-only">Video player</DialogDescription>
                {embed ? (
                    <div className="aspect-video w-full">
                        <iframe
                            title={resource?.title}
                            src={embed}
                            className="w-full h-full"
                            allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                            allowFullScreen
                            data-testid="video-lightbox-iframe"
                        />
                    </div>
                ) : (
                    <div className="p-10 text-center text-[#FBFAF7]">
                        <p className="text-[16px]">This video opens on its own page.</p>
                        <a href={resource?.url} target="_blank" rel="noopener noreferrer" className="mt-5 inline-block underline" data-testid="video-lightbox-external">
                            Open the video
                        </a>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};
